// Export theme utilities and configuration
// Note: CSS files are available as separate imports to avoid SSR issues
// Import them separately: import '@orchard9ai/design-system/dist/grove.css'

// Available theme names
export const themes = {
  // Default themes from DaisyUI
  light: 'light',
  dark: 'dark',
  cupcake: 'cupcake',
  business: 'business',
  // Custom Orchard9 themes
  grove: 'grove',
  // Dawn themes
  dawn: 'dawn',
  dusk: 'dusk',
} as const

export type ThemeName = typeof themes[keyof typeof themes]